import logo from '../assets/logo.png';

const hit99Logo    = '/hit99.png';
const bet99exLogo  = '/bet99ex.png';
const rcb99Logo    = '/rcb99.png';
const max365Logo   = '/max365.png';
const deva99Logo   = '/deva99.png';

const getHostname = () => {
  try { return window.location.hostname.toLowerCase(); } catch { return ''; }
};

const isLocalDev = (hostname) => !hostname || hostname === 'localhost' || hostname === '127.0.0.1';

export const isLotus = () => getHostname().includes('lotus');
export const isHit99 = () => getHostname().includes('hit99');
export const isBet99ex = () => getHostname().includes('bet99ex');
export const isRcb99 = () => getHostname().includes('rcb99');
export const isMax365 = () => getHostname().includes('max365');
export const isDeva99 = () => getHostname().includes('deva99');
// UI theme — DOMAIN-WISE. Kis domain pe kaun si theme: yahin ek line jodo/badlo.
//   'default' = gold + magenta   |   baaki (teal, royal, purple, crimson, emerald, midnight, wbt) = src/config/siteThemes.js
// Jo domain list me nahi, uspe 'default'. Client site me same list: sky99/src/config.js
export const DOMAIN_THEMES = {
  'sky99.co': 'default',
  'hit99.in': 'default',
  'bet99ex.pro': 'default',
  'rcb99.co': 'teal',
  'max365.pro': 'wbt',
  'deva99.co': 'teal',
};
// Code wali theme (backend jawab na de to yahi). Asli theme admin "Site Theme" page se backend AppUrl.theme me.
export const getCodeTheme = () => DOMAIN_THEMES[getBaseDomain()] || 'default';
// Abhi lagi hui theme — main.jsx <html data-theme> set karta hai (cache/code, phir backend se taaza)
export const getTheme = () => {
  try { return document.documentElement.getAttribute('data-theme') || getCodeTheme(); } catch { return getCodeTheme(); }
};

// Logos are real per-brand image assets — can't be derived from the domain,
// so this stays an explicit lookup. Any domain without a dedicated logo
// falls back to the default one.
export const getDomainLogo = () => isHit99() ? hit99Logo : isBet99ex() ? bet99exLogo : isRcb99() ? rcb99Logo : isMax365() ? max365Logo : isDeva99() ? deva99Logo : logo;

// Base domain of wherever this admin panel is actually running, e.g.
// admin.bet99ex.pro → bet99ex.pro. Generic — works for any domain, no
// per-brand list to maintain.
export const getBaseDomain = () => {
  const hostname = getHostname();
  const parts = hostname.split('.');
  if (parts.length >= 3) return parts.slice(1).join('.');
  if (parts.length === 2) return parts.join('.');
  return 'sky99.co'; // last-resort default (e.g. local dev with no real domain)
};

export const getDomainAppUrl = () => getBaseDomain();

// Every brand's backend lives at api.<its own domain> — sky99.co →
// api.sky99.co, hit99.in → api.hit99.in, and so on for any new domain.
export const getApiBaseUrl = () => `https://api.${getBaseDomain()}`;
export const getWsBaseUrl = () => `wss://api.${getBaseDomain()}`;

// Resolves the API base URL to actually use: a manual localStorage override
// always wins (dev/QA escape hatch); on a real deployed domain, route to
// that domain's own backend; on localhost (local dev), fall back to
// whatever the caller passes (env var / local dev default).
export const getResolvedApiBaseUrl = (fallback) => {
  try {
    const custom = localStorage.getItem('custom_base_url');
    if (custom) return custom;
  } catch { /* localStorage unavailable */ }
  if (isLocalDev(getHostname())) return fallback;
  return getApiBaseUrl();
};

// Same resolution as getResolvedApiBaseUrl(), for the WebSocket base URL.
export const getResolvedWsBaseUrl = (fallback) => {
  if (isLocalDev(getHostname())) return fallback;
  return getWsBaseUrl();
};

// Brand name for display text — derived from the domain itself (e.g.
// bet99ex.pro → "Bet99ex"), so a new domain gets a sensible name with no
// code change needed.
export const getSiteName = () => {
  const label = getBaseDomain().split('.')[0] || 'sky99';
  return label.charAt(0).toUpperCase() + label.slice(1);
};
